module.exports = __webpack_public_path__ + "media/trig_room.cfc53dd4.wav";